import { getColor } from "@faire/sdui/lib/getColor";
import { ITile } from "@faire/web-api--source/indigofair/data/ITile";

export const getCssFromStyle = (style: ITile.ITileStyle | undefined) => {
  const css: React.CSSProperties = {};
  if (style === undefined) {
    return css;
  }
  const { background_color, border_color } = style;
  if (background_color) {
    css["backgroundColor"] = getColor(background_color, undefined);
  }
  if (border_color) {
    css["border"] = `1px solid ${getColor(border_color, undefined)}`;
  }
  return css;
};
